module.exports = __webpack_public_path__ + "media/magnifying-glass.31322adb.svg";